/* Joonys Abo-Rabatt-Anzeige im Seal-Widget.
   Hintergrund: Der Abo-Rabatt läuft als automatischer Shopify-Rabatt mit Kaufart
   Abonnement, damit das Pfand nicht mitrabattiert wird. Die Seal Selling Plans
   stehen deshalb auf 0 Prozent und das Widget zeigt von sich aus keine Ersparnis.
   Dieses Skript ergänzt rein im Frontend ein Badge hinter dem Namen der Abo-Option
   und zeigt den Abo-Preis reduziert an, optional mit Streichpreis davor.
   Der echte Preis kommt weiterhin allein vom automatischen Rabatt im Checkout.
   Liest window.JoonysSubsDiscount (aus subs-discount-config.liquid).
   App-sicher: eigenes Asset, dekoriert nur das fertig gerenderte Widget-DOM. */
(function () {
	const cfg = window.JoonysSubsDiscount;
	if (!cfg || !cfg.enabled) return;
	const percent = Number(cfg.percent);
	if (!(percent > 0) || percent >= 100) return;

	// Äußerer Seal-Container, trägt das Produkt-JSON.
	const WIDGET_SELECTOR = '.sealsubs-target-element[data-product]';

	function formatMoney(cents) {
		cents = Math.max(0, Math.round(cents));
		if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && cfg.moneyFormat) {
			try {
				return window.Shopify.formatMoney(cents, cfg.moneyFormat);
			} catch (e) {}
		}
		return (cents / 100).toFixed(2).replace('.', ',') + ' €';
	}

	// "17,99 €" oder "1.017,99 €" zu Cent. Shopify-Money-Formate rendern immer
	// zwei Dezimalstellen, darum reichen die reinen Ziffern.
	function parseCents(text) {
		const digits = String(text || '').replace(/\D/g, '');
		return digits ? parseInt(digits, 10) : NaN;
	}

	// Basispreis der aktuell gewählten Variante. Die Einmalkauf-Zeile ist die
	// verlässlichste Quelle, Seal hält sie bei Variantenwechsel aktuell.
	// Fallback: Produkt-JSON am Widget-Container (Preis der Startvariante).
	function baseCents(widget) {
		const oneTime = widget.querySelector('.sls-one-time-price .money');
		const parsed = oneTime ? parseCents(oneTime.textContent) : NaN;
		if (parsed > 0) return parsed;
		try {
			const product = JSON.parse(widget.getAttribute('data-product'));
			if (product && product.price > 0) return product.price;
		} catch (e) {}
		return NaN;
	}

	// Badge nur an Abo-Optionen (Container mit data-selling-plan-group),
	// die Einmalkauf-Zeile nutzt dieselbe Label-Klasse und bleibt unberührt.
	function applyBadges(widget) {
		const badgeText = String(cfg.badgeText || 'Spare [percent] %').replace('[percent]', percent);
		widget
			.querySelectorAll('.sls-option-container[data-selling-plan-group] .sls-selling-plan-group-name')
			.forEach(function (label) {
				let badge = label.querySelector('.joonys-subs-badge');
				if (!badge) {
					badge = document.createElement('span');
					badge.className = 'joonys-subs-badge';
					label.appendChild(badge);
				}
				if (badge.textContent !== badgeText) badge.textContent = badgeText;
			});
	}

	function applyPrices(widget) {
		const base = baseCents(widget);
		if (!(base > 0)) return;
		// Wie Shopify rechnen: Rabattbetrag auf ganze Cent abrunden und vom
		// Preis abziehen (verifiziert am Cart: 17,99 € / 15 % → Rabatt 2,69 €,
		// Endpreis 15,30 €). Endpreis selbst runden ergäbe 1 Cent Abweichung.
		const discountCents = Math.floor((base * percent) / 100);
		const reducedText = formatMoney(base - discountCents);
		const compareText = formatMoney(base);
		widget
			.querySelectorAll('.sls-selling-plan-group-price .sls-price .money')
			.forEach(function (money) {
				if (money.textContent !== reducedText) money.textContent = reducedText;
				let compare = money.parentElement.querySelector('.joonys-subs-compare');
				if (cfg.showCompare) {
					if (!compare) {
						compare = document.createElement('s');
						compare.className = 'joonys-subs-compare';
						money.parentElement.insertBefore(compare, money);
					}
					if (compare.textContent !== compareText) compare.textContent = compareText;
				} else if (compare) {
					compare.remove();
				}
			});
	}

	function applyAll() {
		document.querySelectorAll(WIDGET_SELECTOR).forEach(function (widget) {
			applyBadges(widget);
			applyPrices(widget);
		});
	}

	// Seal rendert asynchron und re-rendert bei Varianten- und Intervallwechsel,
	// Widgets kommen auch nachträglich dazu (Quick-View). Debounced re-apply.
	// Konvergiert, weil nur bei Abweichung geschrieben wird.
	let scheduled = false;
	function schedule() {
		if (scheduled) return;
		scheduled = true;
		setTimeout(function () {
			scheduled = false;
			applyAll();
		}, 50);
	}

	function start() {
		applyAll();
		new MutationObserver(schedule).observe(document.body, {
			childList: true,
			subtree: true,
			characterData: true,
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();
